import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import { ReportTable } from '../components/reportTable';
import { getDataSource } from '../api/ds';
import { FindTextField } from '../components/FindTextField';
import { FormControlLabel, Switch, Tabs, Tab, styled, Typography, Button, Dialog, TextField, Card, CardContent, IconButton, Tooltip, Checkbox, Divider, Grid, Select, MenuItem, Menu } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { ExpandLess, ExpandMore, Warehouse } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { colors } from '../styles/colors';
import Paper from '@mui/material/Paper';
import { styleTable } from '../components/reportTable';
import { TabPanel } from '../components/tabPanel';
import useOn from 'components/socketLib/UseOn';
import { useDataContextDeal } from 'actions/contextDealClient';
import { useNavigate, useParams, unstable_usePrompt as usePrompt } from 'react-router-dom';
import { AddProducts } from 'components/AddProducts';
import { DateMenu } from 'components/RangeDate';
import { delFts, get, getFile, post, postImage } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { DealTabSelector } from 'store/slices/dealTab';
import Loading from 'components/Load';
import Scrollbars from 'rc-scrollbars';
import { useLocalNotifications } from 'components/Events';
import usePreventDoubleClick from 'components/AntiDBC';
import * as XLSX from 'xlsx';
import { onChangeUploadPDF } from 'store/slices/uploadPDF';
import { onChangeUploadExcel } from 'store/slices/uploadExcel';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { MarketClientSelector } from 'store/slices/marketClient';
import { DealTab, ProductMoreInfo, StyledTab } from 'utils/formatters';
import ClassicSearch from 'components/classicSearch';
import { getDocument } from "pdfjs-dist";
import { GlobalWorkerOptions } from "pdfjs-dist";
import { version } from "pdfjs-dist";
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { ShowModal } from 'components/Modal';
import zIndex from '@mui/material/styles/zIndex';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { NumInputDesign, TextInputDesign } from 'components/EIComponents/LittleComponents';
import { hoverStyle } from "styles/main";
import { sortProducts } from 'utils/globalSorts';
// GlobalWorkerOptions.workerSrc = "/pdf.worker.mjs";
//При таком подходе, если сервак cdn откиснет, то и библа вместе с ним
GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;


function TableDeal({$data, setInfo, setSearch}) {


    const [loading, setLoading] = useState(false);
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    /** @type {[any, Function]} */
    const [market, setMarket] = useState(undefined);
    const [dealNumber, setDealNumber] = useState(null);
    const ds = useMemo(() => {
        //Вообще, зайти в сделку с консумами со стороны клиента мы не можем, но пусть будет
        const $ds = market === "consum"? getDataSource('DealTableForClientConsume'): getDataSource('DealTableForClient')
        return $ds;
    }, [market]);
    
    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            color: {name: "Цвет", active: true},
        }
    );

    const { user_id } = useSelector(
        loginSelector
    );
    
    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)
    const [allEtimated, setAllEtimated] = useState(0)
    const [allDefect, setAllDefect] = useState(0)

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ 
                        fontSize: '14pt', 
                        fontWeight: 'bold', 
                        margin: '5px 15px 5px 10px',
                        color: '#078376'
                    }}>
                        Номер сделки: {dealNumber}
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        SKU: {allSKU} шт.
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        Брак: <Typography component="span" sx={{ fontSize: '12pt', color: allDefect !== 0 ? 'red' : 'inherit' }}>{allDefect} шт.</Typography>
                    </Typography>                            
                    
                    {allEtimated > 0 &&
                        <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px' }}>
                            Заявлено: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated ? 'red' : 'inherit' }}>{allEtimated} шт.</Typography>
                        </Typography>
                    }
                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px' }}>
                        Фактически: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated && allEtimated > 0 ? 'red' : 'inherit' }}>{allProduct} шт.</Typography>
                    </Typography>
                    <Tooltip
                        title={"Скачать список товаров"}
                    >
                        <IconButton 
                            onClick={handleExportClick}
                            sx={{ 
                                marginRight: '5px',
                            }} 
                        >
                            <DownloadIcon
                                sx={{
                                    transition: 'all 0.3s ease',
                                    '&:hover': hoverStyle
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                </>
            )
        }
        setInfo(getInfo())
    }, [dealNumber, allSKU, allProduct, allEtimated, allDefect]);

    useEffect(() => {
        const getSearch = () => {
            return (
                <>
                    <ClassicSearch 
                        setChecked={setChecked} 
                        setFilter={setFilter} 
                        checked={checked}
                        // @ts-ignore
                        fields={filterFields}
                        // @ts-ignore
                        setFields={setFilterFields}
                    />
                </>
            )
        }
        setSearch(getSearch())
    }, [checked, filterFields, setFilter, setChecked, setFilterFields]);


    useOn('updateCountPages', ($data) => {
        let tmp = JSON.parse(JSON.stringify(data))
        if ($data) {
            const index = tmp.findIndex((el) => el.nmID === $data.nmID && el.size.barcode === $data.size);
            if (index !== -1 ) {
                tmp[index].qrCount = $data.count;
                setData(tmp);
            }
        }
    });

    const fetchData = useCallback(async () => {
        try {
            // todo проверка какой маркет выбран
            // добавленный товар исключать путем запроса
            setLoading(true);
    
            // получаем данные
            const responseData = await get('Deal/getHeader', {did:$data})
            if (responseData && responseData.cdn) {
                setDealNumber(responseData.cdn);
            }
            if (responseData && responseData.market) {
                setMarket(responseData.market);
            }

            const res = await get("Deal/GetDeliveryProductOnDeal", {did:$data})

            let allsku = 0
            let allproduct = 0
            let alletimated = 0
            let alldefect = 0

            if (res && res.length > 0){
                allsku = res.length
                for(let i = 0 ; i < res.length ; i++){
                    allproduct += res[i].countProduct;
                    alletimated += res[i].countEtimated;
                    alldefect += res[i].countDefectHist; //Используем hist, чтобы не отображать временные данные ине терять найденную инфу
                }

            }
            
            setAllSKU(allsku)
            setAllEtimated(alletimated)
            setAllProduct(allproduct)
            setAllDefect(alldefect)

            


            let result = []
            console.log("RawData", res)
            for (let card of res) {
                let obj = {
                    id:card.id,
                    nmID:card.nmID,
                    deal_id: card.deal_id,
                    data: {
                        market,
                        vendorCode:card.vendorCode,
                        brand:card.brand,
                        title:card.title,
                        // photo:responseData.market === "consum"? await getFile("png", {path:card.photo}):card.photo,
                        photo:card.photo,
                        color:card.color,
                        dimensions: card.dimensions,
                        material:card.material,
                        barcode:card.size.barcode,
                        sizeTitle:card.size.title,
                        url: card.size.url,
                        nmID: card.size?.ozonID || card.nmID
                    },

                    countAllProduct:{
                        countProduct:card.countProduct,
                        countEtimated:card.countEtimated,
                        countDefect:card.countDefectHist,//Используем hist, чтобы не отображать временные данные ине терять найденную инфу
                    },

                    packageFeatures:{
                        labelsCount:card.labelsCount,
                        craftCount:card.craftCount,
                        bookletCount:card.bookletCount,
                        zapayka:card.zapayka
                        },

                    countProduct:card.countProduct,
                    countEtimated:card.countEtimated,
                    countDefect:card.countDefectHist,//Используем hist, чтобы не отображать временные данные ине терять найденную инфу

                    package:card.package,
                    tags:card.tags,

                    labelsCount:card.labelsCount,
                    craftCount:card.craftCount,
                    bookletCount:card.bookletCount,
                    zapayka:card.zapayka,
                    inbox:card.inbox,

                    dimensions:card.dimensions,
                    size:card.size,
                    qrcode:{id:card.id, qr: card.qr, nmID: card.nmID, size:card.size.barcode,count:card.qrCount,
                        //Ниже для логов
                        deal_id:card.deal_id, 
                        product: {
                            nmID: card.nmID,
                            barcode: card.size.barcode,
                            title: card.title,
                            vendorCode: card.vendorCode
                        },
                        user_id,
                        client_id: user_id,
                        market:responseData.market
                    } ,
                    qrCount: card.qrCount,
                    bind:card.bind
                }
                // card.qr.map((el) => obj.qrCount += parseInt(el.countPages))
                console.log("card.size", card.size)
                result.push(obj)
            }
            
            setData(result)
        }
        catch (err) {}
        finally {setLoading(false);}
    }, [$data]);
    
    useEffect(() => {
        fetchData();
    }, []);

    const handleExportClick = async (event) => {
        if (event) {
            event.preventDefault(); // Предотвращаем действие по умолчанию
            event.stopPropagation(); // Останавливаем всплытие события
        }
        // 1. Создаем новую книгу и лист
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        const DataArray = []; // Ваши данные здесь

        switch (market) {
            case "wb":
            case "custom":
                // 2. Определяем заголовки столбцов
                worksheet.columns = [
                    { header: 'Баркод', key: 'barcode'},
                    { header: 'Количество', key: 'count'},
                ];

                // 3. Добавляем данные (пример с массивом объектов)
                // Предположим, что `data` - это массив объектов вида {id: 1, name: "Товар 1", quantity: 5}

                for (let product of data) {
                    console.log("product", product)
                    DataArray.push({barcode: product.size.barcode, count:product.countProduct})
                }
                break;
            case "ozon":
                // 2. Определяем заголовки столбцов
                worksheet.columns = [
                    { header: 'Артикул', key: 'vendorCode'},
                    { header: 'Имя (необязательно)', key: 'name'},
                    { header: 'Количество', key: 'count'},
                ];

                // 3. Добавляем данные (пример с массивом объектов)
                // Предположим, что `data` - это массив объектов вида {id: 1, name: "Товар 1", quantity: 5}

                for (let product of data) {
                    console.log("product", product)
                    DataArray.push({vendorCode: product.data.vendorCode, name:product.data.title, count:product.countProduct})
                }
                break;
        }

        worksheet.addRows(DataArray);

        // 4. Генерируем файл как буфер
        const buffer = await workbook.xlsx.writeBuffer();

        // 5. Создаем Blob и скачиваем файл
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // saveAs(blob, 'МойФайл.xlsx');
        

        const blobUrl = URL.createObjectURL(blob);

        // alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `Файл с товаром ${market}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // // Открываем новую вкладку с Blob-URL
        // const newTab = window.open(blobUrl, '_blank');

        // // Пытаемся закрыть вкладку через короткую задержку (может быть заблокировано браузером)
        // if (newTab) {
        //     setTimeout(() => {
        //         try {
        //             newTab.close();
        //             console.log('Вкладка для скачивания закрыта.');
        //         } catch (e) {
        //             // Скорее всего, браузер запретил скрипту закрыть вкладку
        //             console.log('Файл открыт в новой вкладке. Пользователь может закрыть ее вручную.');
        //         }
        //     }, 1000); // Задержка 1 секунда
        // } else {
        //     // Если браузер заблокировал открытие новой вкладки, предлагаем скачать файл стандартным способом
        //     alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
        //     const link = document.createElement('a');
        //     link.href = blobUrl;
        //     link.download = 'Распределение_товара.xlsx';
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        // }

        // Всегда освобождаем память от Blob-URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

    }

    if (loading) return (<Loading></Loading>)

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", height: "calc(94% - 55px )", margin: '0% 1% 1% 1%'}}>
                
                {/* <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: "5%", marginBottom: "10px" }}>
                    <ClassicSearch 
                        setChecked={setChecked} 
                        setFilter={setFilter} 
                        checked={checked}
                        // @ts-ignore
                        fields={filterFields}
                        // @ts-ignore
                        setFields={setFilterFields}
                    />

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip
                            title={"Скачать список товаров"}
                        >
                            <IconButton 
                                onClick={handleExportClick}
                                sx={{ 
                                    marginRight: '10px',
                                }} 
                            >
                                <DownloadIcon
                                    sx={{
                                        transition: 'all 0.3s ease',
                                        '&:hover': hoverStyle
                                    }}
                                />
                            </IconButton>
                        </Tooltip>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            borderRadius: '10px',
                        }}>
                            <Typography sx={{ 
                                fontSize: '14pt', 
                                fontWeight: 'bold', 
                                margin: '5px 15px 5px 10px'
                            }}>
                                Номер сделки: {dealNumber}
                            </Typography>
                            <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                                SKU: {allSKU} шт.
                            </Typography>
                            <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                                Брак: <Typography component="span" sx={{ fontSize: '12pt', color: allDefect !== 0 ? 'red' : 'inherit' }}>{allDefect} шт.</Typography>
                            </Typography>                            
                            
                            {allEtimated > 0 &&
                                <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px' }}>
                                    Заявлено: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated ? 'red' : 'inherit' }}>{allEtimated} шт.</Typography>
                                </Typography>
                            }
                            <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px' }}>
                                Фактически: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated && allEtimated > 0 ? 'red' : 'inherit' }}>{allProduct} шт.</Typography>
                            </Typography>
                        </Box>
                    </div>
                </div> */}
                <Scrollbars
                    autoHide
                    style={{ width: '100%', borderRadius: "10px", borderTopLeftRadius:'0px', height: '100%', backgroundColor: 'white'}} 
                    >
                        <ReportTable 
                            ds={ds} 
                            data={!checked? sortProducts(data): sortProducts(data.filter((el) => {const tf = filter.toLowerCase(); 
                                return (
                                    filterFields.title.active && 
                                        el.data.title &&
                                        String(el.data.title).toLowerCase().includes(tf) || 
                                    filterFields.brand.active && 
                                        el.data.brand &&
                                        String(el.data.brand).toLowerCase().includes(tf) || 
                                    filterFields.vendorCode.active && 
                                        el.data.vendorCode &&
                                        String(el.data.vendorCode).toLowerCase().includes(tf) ||
                                    filterFields.barcode.active && 
                                        el.size.barcode && 
                                        String(el.size.barcode).toLowerCase().includes(tf)
                                )}))}
                            autoPagination={15}
                        />
                </Scrollbars>
            </div>
        </>
    );
}

function BindDeal({$data, setInfo}) {
    
    
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    /** @type {[any, Function]} */
    const [data, setData] = useState({});
    /** @type {[Array<any>, Function]} */
    const [boxes, setBoxes] = useState([]);
    /** @type {[any, Function]} */
    const [market, setMarket] = useState(undefined);
    /** @type {[any, Function]} */
    const [allCount, setAllCount] = useState(0);
    /** @type {[Array<any>, Function]} */
    const [allSku, setAllSku] = useState([]);
    const [shipmentCode, setShipmentCode] = useState("");
    const [shipmentNumber, setShipmentNumber] = useState("");
    const [SCChanged, setSCChanged] = useState(false);
    const [SCNhanged, setSCNhanged] = useState(false);
    const $ds = useMemo(() => getDataSource('BindProductsClient'), []);
    const nbds = useMemo(() => getDataSource('NotBindProducts'), []);
    /** @type {[Array<any>, Function]} */
    const [MW, setMW] = useState([]);
    /** @type {[any, Function]} */
    const [FBSDATA, setFBSDATA] = useState(undefined);
    const mwds = useMemo(() => getDataSource('multiWayDeliveryBC'), []);
    const [tab, setTab] = useState('main');
    const changeTab = (event, newValue) => setTab(newValue);
    /** @type {[any, Function]} */
    const [upfOpen, setUpfOpen] = useState(undefined);
    /** @type {[any, Function]} */
    const [dwfOpen, setDwfOpen] = useState(undefined);
    /** @type {[any, Function]} */
    const [dqrlOpen, setDqrlOpen] = useState(undefined);
    /** @type {[any, Function]} */
    const [anchorSettings, setAnchorSettings] = useState(false);// якорь для  меню настроек

    /** @type {[any, Function]} */
    const [selBoxToQrList, setSelBoxToQrList] = useState(undefined);

    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
        }
    );
    /** @type {[Array<any>, Function]} */
    const [finded, setFinded] = useState([]);
    
    const [checkedSub, setCheckedSub] = useState(false);
    /** @type {[any, Function]} */
    const [filterSub, setFilterSub] = useState(null);
    const [filterFieldsMW, setFilterFieldsMW] = useState(
        {
            warehouse: {name: "Склад", active: true},
        }
    );

    /** @type {[any, Function]} */
    const [filterWarehouse, setFilterWarehouse] = useState(undefined);
    /** @type {[Array<any>, Function]} */
    const [avaibleWarehouses, setAvaibleWarehouses] = useState([]);


    const [dealNumber, setDealNumber] = useState(null);
      const [startData, setStartData] = useState({})

    const { showNotification } = useLocalNotifications();
    const { socket } = useContext(SocketContext);

    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)
    const [allEtimated, setAllEtimated] = useState(0)
    const [allDefect, setAllDefect] = useState(0)
    const [boxed, setBoxed] = useState(0)
    const [unboxed, setUnboxed] = useState(0)
    // const [selectedWH, setSelectedWH] = useState("Все");

    const [noPalletOpen, setNoPalletOpen] = useState(true);
    const [idSortOrder, setIdSortOrder] = useState(localStorage.getItem('bindDeal_sortOrder') || 'asc')

    const [inPalletCount, setInPalletCount] = useState({})
    /** @type {[any, Function]} */
    const [openSetBarcodeDialog, setOpenSetBarcodeDialog] = useState(undefined)

    const { user_id } = useSelector(
        loginSelector
    );

    const [bcsc, setBcsc] = useState(0)
    let bcs = []


    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{
                        fontSize: '14pt',
                        fontWeight: 'bold',
                        margin: '5px 15px 5px 10px',
                        color: '#078376'
                    }}>
                        Номер сделки: {dealNumber}
                    </Typography>

                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        SKU: {allSKU} шт.
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'  }}>
                        Брак: <Typography component="span"
                            sx={{ fontSize: '12pt', color: allDefect !== 0 ? 'red' : 'inherit' }}>{allDefect} шт.</Typography>
                    </Typography>

                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                        Не распределено: <Typography component="span">{unboxed} шт.</Typography>
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                        Распределено: <Typography component="span">{boxed} шт.</Typography>
                    </Typography>
                </>
            )
        }
        setInfo(getInfo())
    }, [dealNumber, allSKU, allDefect, unboxed, boxed]);
    

    const fetchData = useCallback(async () => {

        try {
            setLoading(true);
            const res = await get("Deal/GetProductsWithBoxOnDeal", {did:$data})

            const res2 = await get("Deal/GetDeliveryProductOnDeal", {did:$data})
            console.log('START RES', res2)
            if (res2) {
                setStartData(res2)
            }

            const resSC = await get("Deal/getShipmentCode", {did:$data})
            const resSN = await get("Deal/getShipmentNumber", {did:$data})

            let dealRes = await get("Deal/get", {did:$data})
            let deal = dealRes.message
            deal.data = JSON.parse(deal.data)


            const responseData = await get('Deal/getHeader', {did:$data})
            if (responseData && responseData.cdn) {
                setDealNumber(responseData.cdn);
            }
            if (responseData && responseData.market) {
                setMarket(responseData.market);
            }
            const mr = await get("Deal/getMarket", {did: $data}) 
            setShipmentCode(resSC.message) 
            setShipmentNumber(resSN.message) 
            let skulist = []
            let result = {}
            res.map((card) => {
                let obj = {
                    ...card,
                    data: {
                        market:mr,
                        vendorCode:card.vendorCode,
                        brand:card.brand,
                        title:card.title,
                        photo:card.photo,
                        color:card.color,
                        dimensions: card.dimensions,
                        material:card.material,
                        barcode:card.size.barcode,
                        sizeTitle:card.size.title,
                        url: card.size.url,
                        nmID: card.size?.ozonID || card.nmID
                    },
                }
                if (Object.keys(result).includes(""+card.box_id)) {
                    result[card.box_id].push(obj)
                }
                else {result[card.box_id] = [{...obj}]}
                if (card.box_id !== 0 && !skulist.includes(obj.data.barcode)) {skulist.push(obj.data.barcode)}
            })
            console.log("result", result)
            setData(result)
            let resb = []
            const respb = await get("Boxes/GetOnDeal", {did:$data})
            let AC = 0
            respb.map((el) => {
                resb.push({...el, open:false})
                AC += parseInt(el.count)
            })
            setAllCount(AC)
            setAllSku(skulist)
            console.log("resb", resb)
            resb = resb.sort((a, b) => (a.id < b.id ? -1 : b.stocks > a.stocks ? 1 : 0));
            const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
            setBoxes(resb.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));

            let tmpMWShort = []
            const tmpMW = deal.data?.MW || []
            let tmpAW = []
            tmpMW.map((sel) => {if (!tmpAW.includes(sel.warehouse)) {tmpAW.push(sel.warehouse)}})
            tmpAW.map((el) => {
                let bc = 0
                let count = 0
                resb.map((bel) => {if (bel.subWarehouse === el) {bc += 1; count += bel.count}})
                tmpMWShort.push({warehouse: el, countBox: bc, count})
            }) 
            setAvaibleWarehouses(tmpAW)
            setMW(tmpMWShort)
            setFBSDATA(deal.data.fbsdata)
        }
        catch {}
        finally {setLoading(false);}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, []);


    const handleClick = (id) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((fel) => fel.id === id)
        tmp[idx].open = !tmp[idx].open
        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
        setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
    };

    

    const reculcSku = () => {
        let sku = []
        let count = 0
        let tmpPallets = {}
        Object.keys(data).filter((el) => el != "0").map((box) => {
            let boxObj = boxes.find((fel) => fel.id === Number(box))
            console.log("boxObj", boxObj)
            data[box].map((item) => {
                if (!sku.includes(item.data.barcode)) {sku.push(item.data.barcode)}
                count += parseInt(item.countProduct)
                if (boxObj?.parent_id) {
                    if (tmpPallets[boxObj.parent_id]) {
                        if (!tmpPallets[boxObj.parent_id].sku.includes(item.data.barcode)) {
                            tmpPallets[boxObj.parent_id].sku.push(item.data.barcode)
                        }
                        tmpPallets[boxObj.parent_id].count += item.countProduct
                        if (tmpPallets[boxObj.parent_id].subWarehouse !== boxObj.subWarehouse) {tmpPallets[boxObj.parent_id].subWarehouse = undefined}
                    }
                    else {
                        tmpPallets[boxObj.parent_id] = {sku: [item.data.barcode], count: item.countProduct, subWarehouse: boxObj.subWarehouse}
                    }
                }
            })
        })
        setAllSku(sku.length)
        setAllCount(count)
        setInPalletCount(tmpPallets)
    }

    useEffect(() => {
        reculcSku()
    }, [data, boxes]);
    


    const handleFileUpload = (event, selectedWH = 'Все') => {
        console.log("selectedWH", selectedWH)
        // console.log('uploadPDF', event.target.files, socket.id);
        let file = Array.from(event.target.files)[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            // @ts-ignore
            const data = new Uint8Array(e.target.result);
            // Чтение рабочей книги из бинарных данных:cite[1]:cite[6]
            const workbook = XLSX.read(data, { type: 'array' });
            
            // Получение имени первого листа:cite[1]
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // Преобразование листа в JSON:cite[1]
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            let bts = undefined
            let columnIndex = undefined
            let thirdColumnValues = []
            let successCount = 0
            switch (market){
                case "wb":
                    columnIndex = 2

                    // Извлечение данных из 3-го столбца (индекс 2)
                    thirdColumnValues = jsonData
                        .map(row => row[columnIndex]) // Берем третий элемент каждой строки
                        .filter(value => value !== undefined).splice(1); // Игнорируем пустые ячейки
                    
                            

                    if (thirdColumnValues.length>0) {
                        thirdColumnValues = Array.from(new Set(thirdColumnValues));
                        console.log("tmpb", boxes)
                        let tmp = JSON.parse(JSON.stringify(boxes))
                        console.log("tmp", tmp)
                        let mainC = 0
                        let subC = 0
                        if (selectedWH !== "Все") {
                            while (mainC < tmp.length && subC<thirdColumnValues.length) {
                                if (!tmp[mainC].market_code && tmp[mainC].subWarehouse === selectedWH && 
                                    (tmp[mainC].type === 'box' || (tmp[mainC].type === "pallet" && tmp[mainC].sku >0))
                                ) {
                                    tmp[mainC].market_code = String(thirdColumnValues[subC])
                                    post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                    subC +=1
                                    successCount += 1
                                }
                                mainC +=1
                            }
                        }
                        else {
                            while (mainC < tmp.length && subC<thirdColumnValues.length) {
                                if (!tmp[mainC].market_code &&
                                    (tmp[mainC].type === 'box' || (tmp[mainC].type === "pallet" && tmp[mainC].sku >0))
                                ) {
                                    tmp[mainC].market_code = String(thirdColumnValues[subC])
                                    post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                    subC +=1
                                    successCount += 1
                                }
                                mainC +=1
                            }
                        }
                        // setSelectedWH("Все")
                        if (successCount > 0) {
                            showNotification({
                                id: 'fileProcessingError',
                                type: 'success',
                                message: `Успешно установленно ${successCount} ШК`
                            });
                        }
                        else {
                            showNotification({
                                id: 'fileProcessingError',
                                type: 'error',
                                message: `Ни один ШК не установлен`
                            });
                        }
                        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
                        setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
                    }
                    else {
                        showNotification({
                            id: 'fileProcessingError',
                            type: 'error',
                            message: `ШК в таблице не найдены`
                        });
                    }

                    break;
                case "ozon":
                    console.log("selectedWH",selectedWH)
                    console.log("jsonData",jsonData)
                    columnIndex = 5
                    bts = jsonData
                        .map(row => row[columnIndex+1]) // Берем третий элемент каждой строки
                        .filter(value => value !== undefined).splice(1); // Игнорируем пустые ячейки

                    // Извлечение данных из 3-го столбца (индекс 2)
                    thirdColumnValues = jsonData
                        .map(row => row[columnIndex]) // Берем третий элемент каждой строки
                        .filter(value => value !== undefined).splice(1); // Игнорируем пустые ячейки
                    
                            

                    if (thirdColumnValues.length>0) {
                        thirdColumnValues = Array.from(new Set(thirdColumnValues));
                        console.log("bcs", bts)
                        console.log("thirdColumnValues", thirdColumnValues)
                        let tmp = JSON.parse(JSON.stringify(boxes))
                        console.log("tmp", tmp)
                        let mainC = 0
                        let subC = 0
                        if (selectedWH !== "Все") {
                            while (mainC < tmp.length && subC<thirdColumnValues.length) {
                                if (bts[subC] === "Коробка") {
                                    if (!tmp[mainC].market_code && tmp[mainC].subWarehouse === selectedWH && 
                                        tmp[mainC].type === 'box'
                                    ) {
                                        tmp[mainC].market_code = String(thirdColumnValues[subC])
                                        post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                        subC +=1
                                        successCount += 1 
                                    }
                                }
                                else {
                                    if (!tmp[mainC].market_code && tmp[mainC].subWarehouse === selectedWH && 
                                        (tmp[mainC].type === "pallet" && tmp[mainC].sku >0)
                                    ) {
                                        tmp[mainC].market_code = String(thirdColumnValues[subC])
                                        post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                        subC +=1
                                        successCount += 1 
                                    }
                                }
                                mainC +=1
                            }
                        }
                        else {
                            while (mainC < tmp.length && subC<thirdColumnValues.length) {
                                if (bts[subC] === "Коробка") {
                                    if (!tmp[mainC].market_code &&
                                        tmp[mainC].type === 'box'
                                    ) {
                                        tmp[mainC].market_code = String(thirdColumnValues[subC])
                                        post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                        subC +=1
                                        successCount += 1 
                                    }
                                }
                                else {
                                    if (!tmp[mainC].market_code &&
                                        tmp[mainC].type === "pallet" && tmp[mainC].sku >0
                                    ) {
                                        tmp[mainC].market_code = String(thirdColumnValues[subC])
                                        post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                        subC +=1
                                        successCount += 1 
                                    }
                                }
                                mainC +=1
                            }
                        }
                        // setSelectedWH("Все")
                        if (successCount > 0) {
                            showNotification({
                                id: 'fileProcessingError',
                                type: 'success',
                                message: `Успешно установленно ${successCount} ШК`
                            });
                            setUpfOpen(undefined)
                        }
                        else {
                            showNotification({
                                id: 'fileProcessingError',
                                type: 'error',
                                message: `Ни один ШК не установлен`
                            });
                        }
                        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
                        setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
                    }
                    else {
                        showNotification({
                            id: 'fileProcessingError',
                            type: 'error',
                            message: `ШК в таблице не найдены`
                        });
                    }
                    break;
                    case "custom":
                        columnIndex = 2

                        // Извлечение данных из 3-го столбца (индекс 2)
                        thirdColumnValues = jsonData
                            .map(row => row[columnIndex]) // Берем третий элемент каждой строки
                            .filter(value => value !== undefined).splice(1); // Игнорируем пустые ячейки 

                        if (thirdColumnValues.length>0) {
                            thirdColumnValues = Array.from(new Set(thirdColumnValues));
                            console.log("tmpb", boxes)
                            let tmp = JSON.parse(JSON.stringify(boxes))
                            console.log("tmp", tmp)
                            let mainC = 0
                            let subC = 0
                            if (selectedWH !== "Все") {
                                while (mainC < tmp.length && subC<thirdColumnValues.length) {
                                    if (!tmp[mainC].market_code && tmp[mainC].subWarehouse === selectedWH && 
                                        (tmp[mainC].type === 'box' || (tmp[mainC].type === "pallet" && tmp[mainC].sku >0))
                                    ) {
                                        tmp[mainC].market_code = String(thirdColumnValues[subC])
                                        post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                        subC +=1
                                        successCount += 1
                                    }
                                    mainC +=1
                                }
                            }
                            else {
                                while (mainC < tmp.length && subC<thirdColumnValues.length) {
                                    if (!tmp[mainC].market_code &&
                                        (tmp[mainC].type === 'box' || (tmp[mainC].type === "pallet" && tmp[mainC].sku >0))
                                    ) {
                                        tmp[mainC].market_code = String(thirdColumnValues[subC])
                                        post('Boxes/update', {id:tmp[mainC].id, market_code:thirdColumnValues[subC]})
                                        subC +=1
                                        successCount += 1
                                    }
                                    mainC +=1
                                }
                            }
                            // setSelectedWH("Все")
                            if (successCount > 0) {
                                showNotification({
                                    id: 'fileProcessingError',
                                    type: 'success',
                                    message: `Успешно установленно ${successCount} ШК`
                                });
                            }
                            else {
                                showNotification({
                                    id: 'fileProcessingError',
                                    type: 'error',
                                    message: `Ни один ШК не установлен`
                                });
                            }
                            const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
                            setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
                        }
                        else {
                            showNotification({
                                id: 'fileProcessingError',
                                type: 'error',
                                message: `ШК в таблице не найдены`
                            });
                        }

                        break;
            }
        };
        reader.readAsArrayBuffer(file); // Чтение файла как ArrayBuffer:cite[1]:cite[6]
    }

    useOn('uploadozonBoxBarcodePdf', async (data) => {
        console.log("uploadozonBoxBarcodePdf", data);
        bcs.push({bid: data.bid, path: data.path})
        console.log("bcs len", bcs.length, bcsc)
        if (bcs.length === bcsc) {
            console.log('bcs', bcs)
            let tmp = JSON.parse(JSON.stringify(boxes))
            bcs.map((el) => {
                let idx = tmp.findIndex((fel) => fel.id === el.bid)
                if (idx > -1) {
                    tmp[idx].marcket_bc_path = el.path
                }
            })
            bcs = []
            setBcsc(0)
            const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
            setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
        }
    });



    const handlePdfUpload = async (event) => {
        let selectedFiles = Array.from(event.target.files);
        
        if (!selectedFiles || selectedFiles.length === 0) {
            return;
        }
        
        showNotification({
            id: 'uploadCustomBCImage',
            type: 'info',
            message: 'Загрузка'
        });
        
        // Обрабатываем все файлы
        let pages = [];
        
        for (const file of selectedFiles) {
            try {
                // Проверяем тип файла
                // Преобразуем одностраничный PDF в изображение
                    let tmppages = await convertPagesPdfToImage(file);
                    if (!tmppages) {
                        console.warn(`PDF файл ${file.name} не был преобразован`);
                    }
                    else {
                        pages = pages.concat(tmppages)
                    }
            } catch (error) {
                console.error(`Ошибка обработки файла ${file.name}:`, error);
                showNotification({
                    id: 'fileProcessingError',
                    type: 'error',
                    message: `Ошибка обработки файла ${file.name}`
                });
                showNotification({
                    id: 'fileProcessingErrorDEBUG',
                    type: 'error',
                    message: `Покажите это администратору ${error}`
                });
            }
        }
        
        // Если есть обработанные файлы, отправляем их
        if (pages.length > 0) {
            try {
                let tbcsc = 0
                for (let page of pages) {
                    let idx = boxes.findIndex((fel) => fel.market_code === page.box_bc)
                    console.log("idx", idx)
                    if (idx > -1) {
                        tbcsc += 1
                        await postImage([page.imageFile], socket.id, {
                            user_id: user_id,
                            role: 'ozonBoxBarcodePdf',
                            content_type: "ozonBoxBarcodePdf",
                            bbc: page.box_bc,
                            bid: boxes[idx].id
                        });
                    }
                    else {
                        showNotification({
                            id: 'noFind',
                            type: 'error',
                            message: `Не найден короб с кодом ${page.box_bc}`
                        });        
                    }
                }
                setBcsc(tbcsc)

                
            } catch (error) {
                console.error('Ошибка при отправке файлов:', error);
                showNotification({
                    id: 'uploadError',
                    type: 'error',
                    message: 'Ошибка при загрузке файлов'
                });
            }
        } else {
            showNotification({
                id: 'noValidFiles',
                type: 'warning',
                message: 'Не удалось преобразовать файл'
            });
        }
        
        // Очищаем поле выбора файлов
        event.target.value = '';
        selectedFiles = [];
    };

    // Функция преобразования одностраничного PDF в PNG изображение
    const convertPagesPdfToImage = async (pdfFile) => {
        try {
            
            // Читаем файл как ArrayBuffer
            const arrayBuffer = await pdfFile.arrayBuffer();
            
            // Загружаем PDF документ
            const pdfDocument = await getDocument({ 
                data: arrayBuffer,
                // Опциональные параметры для лучшей производительности
                cMapUrl: 'https://unpkg.com/pdfjs-dist@2.16.105/cmaps/',
                cMapPacked: true,
            }).promise;
            
            // Проверяем количество страниц
            const numPages = pdfDocument.numPages;
            console.log(`PDF содержит ${numPages} страниц`);
            
            let result = []
            let c = 1
            while (c<=numPages) {
                const page = await pdfDocument.getPage(c);
                const pinfo =  await page.getTextContent()
                // @ts-ignore
                let box_bc = pinfo.items[pinfo.items.length-1].str
                // Настраиваем параметры рендеринга
                const scale = 3.0; // Высокое разрешение для качественной печати
                const viewport = page.getViewport({ scale });
                
                // Создаем временный canvas для рендеринга
                const canvas = document.createElement('canvas');
                /** @type {any} */
                const context = canvas.getContext('2d');
                
                // Устанавливаем размеры canvas
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                canvas.style.width = `${viewport.width / scale}px`;
                canvas.style.height = `${viewport.height / scale}px`;
                
                // Настраиваем фон для прозрачности
                context.fillStyle = 'white';
                context.fillRect(0, 0, canvas.width, canvas.height);
                
                // Рендерим страницу PDF на canvas
                const renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                    // Дополнительные опции для лучшего качества
                    enableWebGL: false,
                    useWorker: false,
                };
                
                await page.render(renderContext).promise;
                
                // Конвертируем canvas в Blob (PNG)
                const blob = await new Promise((resolve) => {
                    canvas.toBlob(resolve, 'image/png', 1.0);
                });
                
                if (!blob) {
                    throw new Error('Не удалось создать изображение из PDF');
                }
                
                // Создаем новый файл с расширением PNG
                // const fileName = pdfFile.name.replace(/\.pdf$/i, `p${c}.png`);
                const fileName = `${box_bc}.png`;
                const imageFile = new File([blob], fileName, {
                    type: 'image/png',
                    lastModified: Date.now()
                });
                
                console.log(`PDF успешно преобразован в PNG: ${fileName} (${Math.round(blob.size / 1024)}KB)`);
                
                // Очищаем ресурсы
                canvas.remove();
                c +=1
                result.push({imageFile, box_bc})
            }
            pdfDocument.destroy();
            return result
            
        } catch (error) {
            console.error('Ошибка при преобразовании PDF в изображение:', error);
            
            showNotification({
                id: 'pdfConversionError',
                type: 'error',
                message: `Ошибка при обработке PDF "${pdfFile.name}"`
            });
            
            return null;
        }
    };

    const toShortFormat = (s) => {
        return s.split('_').filter((_, i, a) => i === 0 || i === a.length-1).join('_')
    }

    const handleExportClick = async (event, selectedWH = 'Все', includeBoxTitles = false) => {
        setDownloadLoading(true)
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        let filename = 'Привязка';
        const DataArray = [];

        switch (market) {
            case "wb":
                filename += " wb"
                let columnsWb = [
                    { header: 'Баркод товара', key: 'barcode'},
                    { header: 'Кол-во товаров', key: 'count'},
                    { header: 'ШК короба', key: 'market_code'},
                    { header: 'Срок годности', key: 'date'}
                ];
                // Используем unshift, чтобы колонка стала ПЕРВОЙ
                if (includeBoxTitles) {
                    columnsWb.unshift({ header: 'Название короба', key: 'title' });
                }
                worksheet.columns = columnsWb;

                for (let box of boxes) {
                    let list = data[box.id]
                    if (list) {
                        for (let product of list) {
                            DataArray.push({barcode: product.size.barcode, count:product.countProduct, market_code:box.market_code, date:"", title: toShortFormat(box.title)})
                        }
                    }
                }
                break;

            case "custom":
                filename += " wb"
                let columnsCustom = [
                    { header: 'Баркод товара', key: 'barcode'},
                    { header: 'Кол-во товаров', key: 'count'},
                    { header: 'ШК короба', key: 'market_code'},
                    { header: 'Срок годности', key: 'date'}
                ];
                // Используем unshift, чтобы колонка стала ПЕРВОЙ
                if (includeBoxTitles) {
                    columnsCustom.unshift({ header: 'Название короба', key: 'title' });
                }
                worksheet.columns = columnsCustom;

                for (let box of boxes) {
                    let list = data[box.id]
                    if (list) {
                        for (let product of list) {
                            DataArray.push({barcode: product.size.barcode, count:product.countProduct, market_code:box.market_code, date:"", title: toShortFormat(box.title)})
                        }
                    }
                }
                break;

            case "ozon":
                filename += " ozon"
                let columnsOzon = [
                    { header: 'ШК товара', key: 'barcode'},
                    { header: 'Артикул товара', key: 'vendorCode'},
                    { header: 'Кол-во товаров', key: 'count'},
                    { header: 'Зона размещения', key: 'zone'},
                    { header: 'Срок годности ДО в формате YYYY-MM-DD (не более 1 СГ на 1 SKU в 1 ГМ)', key: 'date'},
                    { header: 'ШК ГМ', key: 'market_code'},
                    { header: 'Тип ГМ (не обязательно)', key: 'box_type'}
                ];
                // Используем unshift, чтобы колонка стала ПЕРВОЙ
                if (includeBoxTitles) {
                    columnsOzon.unshift({ header: 'Название короба', key: 'title' });
                }
                worksheet.columns = columnsOzon;

                if (selectedWH === "Все") {
                    for (let box of boxes) {
                        let list = data[box.id]
                        if (list) {
                            for (let product of list) {
                                let zone = "Cортируемый товар"
                                let gm = 1
                                let wm = 1
                                switch (product.dimensions.gabarit_unit){
                                    case "mm": gm = 0.1
                                    case "cm": gm = 1
                                    case "in": gm = 2.54
                                }
                                switch (product.dimensions.weight_unit){
                                    case "g": wm = 0.001
                                    case "kg": wm = 1
                                }
                                if (
                                    (product.dimensions.width && product.dimensions.width*gm >32) || 
                                    (product.dimensions.height && product.dimensions.height*gm >32) || 
                                    (product.dimensions.length && product.dimensions.length*gm >45) || 
                                    (product.dimensions.weight && product.dimensions.weight*wm >10)
                                ) {zone = "Несортируемый товар"}
                                DataArray.push({barcode: product.size.barcode, vendorCode: product.vendorCode, count:product.countProduct, zone, market_code:box.market_code, box_type:"Коробка", date:"", title: toShortFormat(box.title)})
                            }
                        }
                    }
                }
                else {
                    filename += ` ${selectedWH}`
                    for (let box of boxes) {
                        if (box.subWarehouse === selectedWH) {
                            let list = data[box.id]
                            if (list) {
                                for (let product of list) {
                                    let zone = "Cортируемый товар"
                                    let gm = 1
                                    let wm = 1
                                    switch (product.dimensions.gabarit_unit){
                                        case "mm": gm = 0.1
                                        case "cm": gm = 1
                                        case "in": gm = 2.54
                                    }
                                    switch (product.dimensions.weight_unit){
                                        case "g": wm = 0.001
                                        case "kg": wm = 1
                                    }
                                    if (
                                        (product.dimensions.width && product.dimensions.width*gm >32) || 
                                        (product.dimensions.height && product.dimensions.height*gm >32) || 
                                        (product.dimensions.length && product.dimensions.length*gm >45) || 
                                        (product.dimensions.weight && product.dimensions.weight*wm >10)
                                    ) {zone = "Несортируемый товар"}
                                    DataArray.push({barcode: product.size.barcode, vendorCode: product.vendorCode, count:product.countProduct, zone, market_code:box.market_code, box_type:"Коробка", date:"", title: toShortFormat(box.title)})
                                }
                            }
                        }
                    }
                }
                break;
        }
        
        worksheet.addRows(DataArray);
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${filename}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
        setDownloadLoading(false)
    }

    
    const handleExportClickQRList = async (event, selectedWH = 'Все', includeBoxTitles = false) => {
        setDownloadLoading(true)
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        let filename = `Список КИЗов сделки ${dealNumber}`;
        const DataArray = [];
        let columnsOzon = [
            { header: 'КОД', key: 'code'}
        ];
        // Используем unshift, чтобы колонка стала ПЕРВОЙ
        if (includeBoxTitles) {
            columnsOzon.unshift({ header: 'Короба', key: 'title' });
        }
        worksheet.columns = columnsOzon;

        let tmp = [...boxes]
        console.log("selBoxToQrList", selBoxToQrList)
        if (selBoxToQrList) {
            tmp = tmp.filter((fel) => fel.id === selBoxToQrList )
        }
        console.log("tmp", tmp)

        if (selectedWH === "Все") {
            for (let box of tmp) {
                if (box.qrList){
                    for (let code of box.qrList) {
                        DataArray.push({
                            title: toShortFormat(box.title),
                            code
                        })
                    }
                }
                
            }
        }
        else {
            filename += ` ${selectedWH}`
            for (let box of tmp) {
                if (box.subWarehouse === selectedWH) {
                    if (box.qrList){
                        for (let code of box.qrList) {
                            DataArray.push({
                                title: toShortFormat(box.title),
                                code
                            })
                        }
                    }
                }
            }
        }
        if (selBoxToQrList) {
            filename += ` - ${tmp[0].title}`
        }

        setSelBoxToQrList(undefined)
        
        worksheet.addRows(DataArray);
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${filename}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
        setDownloadLoading(false)
    }

    const handleExportClickQRListFBS = async () => {
        
        
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        let filename = `Список КИЗов сделки ${dealNumber}`;
        const DataArray = [];
        worksheet.columns = [
            { header: 'Баркод', key: 'barcode' },
            { header: 'КИЗ', key: 'code'}
        ];

        console.log("FBSDATA.qrList", FBSDATA)
        for (let item of Object.values(FBSDATA.qrList).flat()) {
            console.log("item", item)
            DataArray.push({
                barcode: FBSDATA.order_barcodes.find((fel) => fel.order === item.order).barcode,
                code: item.code
            })
        }
        
        worksheet.addRows(DataArray);
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${filename}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    }

    const saveShipmentCode = useCallback(async () => {
        const regex = /^WB-GI-\d+$/;
        if (regex.test(shipmentCode)) {
            await post("Deal/update", {id:$data, data:{shipmentCode}, user_id, user_type: "cli"})
            setSCChanged(false);
        }
        else {
            showNotification({
                id: 'errorShipmentCode', 
                type: 'error', 
                message: 'Код поставки не подходит под формат WB-GI-000000000' 
            });
        }
    }, [$data, shipmentCode]);

    const saveShipmentNumber = useCallback(async () => {
        await post("Deal/update", {id:$data, data:{shipmentNumber}, user_id, user_type: "cli"})
        setSCNhanged(false);
    }, [$data, shipmentNumber]);

    const handleClickDelBarcode = () => {
        ShowModal('Удалить ШК коробов', 
        <div>Вы уверены, что хотите очистить все шк коробов?</div>, 
        async () => {
            try {
                setLoading(true)
                let tmp = JSON.parse(JSON.stringify(boxes))
                for (let el of tmp) {
                    if (el.market_code) {
                        el.market_code = ""
                        if (el.marcket_bc_path) {
                            delFts('/delete-file', {path:[el.marcket_bc_path], taskType: "delImage"}, socket.id)
                            el.marcket_bc_path = ""
                        }
                        post('Boxes/update', {id:el.id, market_code:"", marcket_bc_path: "" })
                    }
                }
                const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
                setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
            }
            catch (err) {}
            finally {setLoading(false)}
            
        });
    }

    const handleClickDelBarcodeOnId = (id) => {
        ShowModal('Удалить ШК короба', 
        <div>Вы уверены, что хотите удалить шк короба?</div>, 
        async () => {
            try {
                setLoading(true)
                
                let idx = boxes.findIndex((el) => el.id === id)
                delete boxes[idx].openMenu
                let tmp = JSON.parse(JSON.stringify(boxes))
                console.log("IDX", idx)
                if (idx>-1) {
                    tmp[idx].market_code = ""
                    if (tmp[idx].marcket_bc_path) {
                        delFts('/delete-file', {path:[tmp[idx].marcket_bc_path], taskType: "delImage"}, socket.id)
                        tmp[idx].marcket_bc_path = ""
                    }
                    post('Boxes/update', {id:tmp[idx].id, market_code:"", marcket_bc_path: "" })
                }
                const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
                setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
            }
            catch (err) {console.log(err)}
            finally {setLoading(false)}
            
        });
    }

    const handleClickSetBarcodeOnId = (id) => {
        setOpenSetBarcodeDialog(id)
    } 

    // const [allProduct, setAllProduct] = useState(0)
    // const [allEtimated, setAllEtimated] = useState(0)

    const counttest = () =>{
            if (!startData) return;
    
            let startKeys = Object.keys(startData)
            let allproduct = 0
            let alldefect = 0
            let allsku = startKeys.length
            let boxed = 0
            let unboxed = 0
    
            if (boxes && boxes.length > 0) {
                for (let box of boxes){
                    boxed += box.count || 0
                }
            }
    
            for (let key of startKeys){
                let dataprod = startData[key]
                allproduct += dataprod.countProduct || 0
            }
    
            unboxed = allproduct - boxed
            
            setAllSKU(allsku)
            setAllDefect(alldefect)
            setUnboxed(unboxed)
            setBoxed(boxed)
        }
    
        useEffect(() => {
            counttest()
        }, [data, boxes, startData]);


    console.log("DATA", data)
    console.log("BOXES", boxes)


    const showPdf = (path) => {
        ShowModal('ШК короба', 
        <div style={{ height: '300px', width: '500px', padding: '12px' }}><BoxCustomPdfModal path={path}/></div>, 
        undefined);
    }


   const chooseLocateUpload = () => {
        let tmpAW = ["Все"]
        boxes.map((sel) => {if (sel.subWarehouse && !tmpAW.includes(sel.subWarehouse)) {tmpAW.push(sel.subWarehouse)}})
        setUpfOpen(tmpAW)
        
        // ShowModal('ШК коробов', 
        //     <ChooseLocateModalUpload tmpAW={tmpAW} />, 
        //     undefined,
        //     99998
        // );
    }

    const chooseLocateDownload = () => {
        let tmpAW = ["Все"]
        boxes.map((sel) => {if (sel.subWarehouse && !tmpAW.includes(sel.subWarehouse)) {tmpAW.push(sel.subWarehouse)}})
        setDwfOpen(tmpAW)
        
        // ShowModal('Скачать привязку коробов', 
        //     <ChooseLocateModalDownLoad tmpAW={tmpAW} />, 
        //     undefined,
        //     99998
        // );
    }

    const chooseLocateQRListDownload = (box = undefined) => {
        let tmpAW = ["Все"]
        if (!box) {
            boxes.map((sel) => {if (sel.subWarehouse && !tmpAW.includes(sel.subWarehouse)) {tmpAW.push(sel.subWarehouse)}})
        }
        else {
            setSelBoxToQrList(box)
        }
        setDqrlOpen(tmpAW)
        
        // ShowModal('Скачать привязку коробов', 
        //     <ChooseLocateModalDownLoad tmpAW={tmpAW} />, 
        //     undefined,
        //     99998
        // );
    }


    const ChooseLocateModalUpload = ({ tmpAW }) => {
        const [selectedWHLocal, setSelectedWHLocal] = useState("Все");
        if (!tmpAW) {return <></>}
        return (
            <div style={{ height: '150px', width: '300px', padding: '12px'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: "12px"}}>Направление</Typography>
                    <Select
                        displayEmpty
                        value={selectedWHLocal}
                        onChange={(event) => {setSelectedWHLocal(event.target.value)}}
                        sx={{width: "250px", height: "25px", marginBottom:"10px"}}
                        MenuProps={{
                            style: {
                                zIndex: 99999, // Установите значение больше, чем у модального окна
                            },
                            PaperProps: {
                                style: {
                                    maxHeight: 200, // Ограничение высоты, если много элементов
                                    zIndex: 99999,
                                }
                            }
                        }}
                    >
                        {tmpAW.map(sel => {
                            return (
                                <MenuItem 
                                    key={sel} 
                                    value={sel} 
                                    style={{ borderRadius:'10px', marginBottom: '5px'}}
                                >
                                    {sel}
                                </MenuItem>
                            )
                        })}
                    </Select>
                    <input
                        type="file"
                        accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style={{ display: "none" }}
                        id="upload-excel_button"
                        onChange={(e) => {handleFileUpload(e, selectedWHLocal)}}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <Button 
                        onClick={() => {
                            // setSelectedWH(selectedWHLocal)
                            const fileInput = document.getElementById('upload-excel_button');
                            if (fileInput) {
                                fileInput.click();
                            }
                        }}
                        variant="contained" 
                        sx={{
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            backgroundColor:'#078376',
                            '&:hover': {
                            backgroundColor: '#045b52',
                            }
                        }}
                        >
                        Загрузить
                        </Button>

                        <input
                            type="file"
                            accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            style={{ display: "none" }}
                            id="upload-excel_button"
                            onChange={handleFileUpload}
                        />
                </div>
            </div>
        );
    }

    const ChooseLocateModalDownLoad = ({ tmpAW, action }) => {
        const [selectedWHLocal, setSelectedWHLocal] = useState("Все");
        const [includeBoxTitles, setIncludeBoxTitles] = useState(false); // Добавлен стейт
        if (!tmpAW) {return <></>}
        return (
            <div style={{ height: 'auto', minHeight: '150px', width: '300px', padding: '12px'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    {tmpAW.length > 1 && 
                        <>
                        <Typography sx={{ fontWeight: 'bold', fontSize: "12pt"}}>Направление</Typography>
                        <Select
                            displayEmpty
                            value={selectedWHLocal}
                            onChange={(event) => {setSelectedWHLocal(event.target.value)}}
                            sx={{width: "250px", height: "25px", marginBottom:"10px"}}
                            MenuProps={{
                                style: {
                                    zIndex: 99999,
                                },
                                PaperProps: {
                                    style: {
                                        maxHeight: 200,
                                        zIndex: 99999,
                                    }
                                }
                            }}
                        >
                            {tmpAW.map(sel => {
                                return (
                                    <MenuItem 
                                        key={sel} 
                                        value={sel} 
                                        style={{ borderRadius:'10px', marginBottom: '5px'}}
                                    >
                                        {sel}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                        </>
                    }

                    {/* Добавлен переключатель */}
                    <FormControlLabel
                        control={
                            <Switch
                                checked={includeBoxTitles}
                                onChange={(e) => setIncludeBoxTitles(e.target.checked)}
                                size="small"
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#078376',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#078376',
                                    },
                                }}
                            />
                        }
                        label={<Typography sx={{ fontSize: '12px' }}>Добавить номера коробов</Typography>}
                        sx={{ marginBottom: '10px' }}
                    />

                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div></div>
                        <Button 
                            onClick={(e) => {action(e, selectedWHLocal, includeBoxTitles)}} // Передаем новое значение
                            variant="contained" 
                            sx={{
                                textTransform: 'none', 
                                fontWeight: 'bold', 
                                backgroundColor:'#078376',
                                '&:hover': {
                                backgroundColor: '#045b52',
                                },
                                fontSize: "12pt"
                            }}
                        >
                            Скачать
                        </Button>
                        {downloadLoading? <Loading/>: <div></div>}
                    </div>
                </div>
            </div>
        );
    }

    const SetBarcodeDialog = ({val, onSet, onClose}) => {
        
        let text = useRef(val || "")
        console.log("TEXT", text.current)
        return (
            <div style={{ height: 'auto', minHeight: '100px', width: '300px', padding: '12px'}}>
                <TextInputDesign val={text.current} title={"Код короба"} onChange={(v) => {text.current = v}}/>
                <div style={{display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'space-between', marginTop: "30px"}}>
                    <Button 
                        onClick={(e) => {onClose()}} // Передаем новое значение
                        variant="contained" 
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                            backgroundColor: "grey.500",
                            "&:hover": { backgroundColor: "grey.600" },
                        }}
                        >
                        Отмена
                    </Button>
                    <Button 
                        onClick={(e) => {onSet(text.current);}} // Передаем новое значение
                        variant="contained" 
                        sx={{
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            backgroundColor:'#078376',
                            '&:hover': {
                            backgroundColor: '#045b52',
                            }
                        }}
                        >
                        Сохранить
                    </Button>
                </div>
            </div>
        );
    }

    const handleIdSort = () => {
        const nextOrder = idSortOrder === 'asc' ? 'desc' : 'asc';
        setIdSortOrder(nextOrder);
        
        // Сохраняем в localStorage
        localStorage.setItem('bindDeal_sortOrder', nextOrder);

        const sortedBoxes = [...boxes].sort((a, b) => {
            return nextOrder === 'asc' ? a.id - b.id : b.id - a.id;
        });

        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
        setBoxes(sortedBoxes.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}));
    };

    const handleClickMenuOpen = (event, id) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        tmp[idx].openMenu = event.currentTarget
        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
        setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}))
    }

    const handleClickMenuClose = (id) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        tmp[idx].openMenu = null
        tmp[idx].openSelectPallet = null
        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';
        setBoxes(tmp.sort((a, b) => {return currentSort === 'asc' ? a.id - b.id : b.id - a.id;}))
    }

    const openSettings = Boolean(anchorSettings);// открыт ли Popover настроек
    //Функции для открытия и закрытия настроек
    const openMenuSettigs = (event) => {
        setAnchorSettings(event.currentTarget);
    }

    const handleCloseSettings = () => {
        setAnchorSettings(null);
    };

    const setBoxMarketCode = (id, val) => {
        console.log("setBoxMarketCode", id, val)
        let tmp = [...boxes]
        let idx = tmp.findIndex((fel) => fel.id === id)
        if (idx > -1) {
            tmp[idx].market_code = val
            setBoxes(tmp)
        }
        setOpenSetBarcodeDialog(undefined)
    }

    

    function EllipsisWithTooltip({ children, style }) {
        const textRef = useRef(null);
        const [isOverflowed, setIsOverflowed] = useState(false);

        useEffect(() => {
            /** @type {any} */
            const el = textRef.current;
            if (el) {
            setIsOverflowed(el.scrollWidth > el.clientWidth);
            }
        }, [children]);

        return (
            <Tooltip title={isOverflowed ? children : ""}>
                <Typography
                    ref={textRef}
                    variant="subtitle2"
                    align="right"
                    style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flexShrink: 0,
                    ...style
                    }}
                >
                    {children}
                </Typography>
            </Tooltip>
        );
        }

    const productItem = (el, datael) => {
        return (
            <div key={`pritem${datael.id}`} style={{width: '48%', margin: "5px 1% 0px 1%", display: 'flex', flexDirection: 'column', backgroundColor: (finded || []).includes(datael.id)? 'rgba(189, 219, 221, 0.4)': "white"}}>
                <ProductMoreInfo value={datael.data}/>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <NumInputDesign 
                        title={"Количество"} 
                        val={datael.countProduct}
                        editable={false}
                    />
                </div>
            </div>
        )
    }

    if (loading) return (<Loading></Loading>)

    return( 
        <div style={{display: "flex", flexDirection: "column", height: "calc(94% - 55px )", margin: '0% 1% 1% 1%', width: '98%'}}>
            <Dialog
                open={upfOpen != undefined}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setUpfOpen(undefined) }}
            >
                <div style={{padding: '12px', }}>
                    <ChooseLocateModalUpload tmpAW={upfOpen} />, 
                </div>
            </Dialog>
            <Dialog
                open={dwfOpen != undefined}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setDwfOpen(undefined) }}
            >
                <div style={{padding: '12px', }}>
                    <ChooseLocateModalDownLoad tmpAW={dwfOpen} action={handleExportClick}/>, 
                </div>
            </Dialog>
            <Dialog
                open={dqrlOpen != undefined}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setDqrlOpen(undefined) }}
            >
                <div style={{padding: '12px', }}>
                    <ChooseLocateModalDownLoad tmpAW={dqrlOpen} action={handleExportClickQRList}/>, 
                </div>
            </Dialog>
            <Dialog
                open={openSetBarcodeDialog !== undefined}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenSetBarcodeDialog(undefined) }}
            >
                <div style={{padding: '12px', }}>
                    <SetBarcodeDialog val={boxes.find((fel) => fel.id === openSetBarcodeDialog)?.market_code} onClose={() => {setOpenSetBarcodeDialog(undefined)}} onSet={(v) => {setBoxMarketCode(openSetBarcodeDialog, v)}}/>, 
                </div>
            </Dialog>

            <div style={{display:'flex', flexDirection:"row", height: "100%", width: '100%', justifyContent: 'space-between'}}>
                <Card sx={{ borderRadius: '10px', boxShadow: 0,  width: "64%", height: "100%"}}>
                    <div style={{marginTop: "15px", marginLeft: "15px", marginRight:"15px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
                        <Typography variant='h3' align='left'>Распределение товара:</Typography>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center'}}>

                            <TextField
                                placeholder='Поставка №'
                                value={shipmentNumber}
                                size={"small"}
                                sx={{width: "150px", marginRight:'20px'}}
                                variant="outlined"
                                onChange={(event) => {setSCNhanged(true); setShipmentNumber(event.target.value)}}
                                InputProps={{
                                    endAdornment:(
                                        <div>
                                            {SCNhanged && 
                                                <IconButton onClick={saveShipmentNumber}>
                                                    <SaveIcon/>
                                                </IconButton>
                                            }
                                        </div>
                                    )
                                }}
                            />

                            <TextField
                                placeholder='Код поставки'
                                value={shipmentCode}
                                size={"small"}
                                sx={{width: "250px"}}
                                variant="outlined"
                                onChange={(event) => {setSCChanged(true); setShipmentCode(event.target.value)}}
                                InputProps={{
                                    endAdornment:(
                                        <div>
                                            {SCChanged && 
                                                <IconButton onClick={saveShipmentCode}>
                                                    <SaveIcon/>
                                                </IconButton>
                                            }
                                        </div>
                                    )
                                }}
                            />

                            <input
                                type="file"
                                accept=".pdf, application/pdf"
                                style={{ display: "none" }}
                                id="upload-pdf"
                                onChange={handlePdfUpload}
                                multiple
                                //disabled={upload}
                            />
                            <input
                                type="file"
                                accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                style={{ display: "none" }}
                                id="upload-excel"
                                onChange={handleFileUpload}
                                //disabled={upload}
                            />

                            <Tooltip title="Действия">
                                <IconButton aria-label="itemMenu" onClick={openMenuSettigs}>
                                    <MoreVertIcon
                                        sx={{
                                            transition: 'all 0.3s ease',
                                            '&:hover': hoverStyle
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id="basic-menu"
                                // @ts-ignore
                                anchorEl={anchorSettings}
                                open={openSettings}
                                onClose={handleCloseSettings}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={handleClickDelBarcode}>Очистить ШК коробов</MenuItem>
                                <MenuItem onClick={() => {chooseLocateDownload()}}>Скачать привязку товара</MenuItem>
                                {!FBSDATA && <MenuItem onClick={() => {chooseLocateQRListDownload()}}>Скачать список КИЗов</MenuItem>}
                                {FBSDATA && FBSDATA.qrList && Object.keys(FBSDATA.qrList).length > 0 && <MenuItem onClick={() => {handleExportClickQRListFBS()}}>Скачать список КИЗов FBS</MenuItem>}
                                {market === "ozon" && 
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <label 
                                            htmlFor="upload-pdf" 
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: 0,
                                                padding: 0,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <MenuItem>Загрузить PDF коробов</MenuItem>
                                        </label>
                                    </div>
                                }
                                {(market === "wb" || market=== 'custom') && 
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <label htmlFor="upload-excel" 
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: 0,
                                                padding: 0,
                                                cursor: 'pointer'
                                            }}>
                                            <MenuItem>Загрузить ШК коробов</MenuItem>
                                        </label>
                                    </div>
                                }
                                {market === 'ozon' && <MenuItem onClick={() => {chooseLocateUpload()}}>Загрузить ШК коробов</MenuItem>}
                            </Menu>
                        </div>
                    </div>

                    <div style={{marginTop: "5px", marginLeft: "25px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant='body1' align='left'>
                                {allSku.length} SKU {allCount} шт. {boxes.filter(box => box.type === 'box').length} короб.
                            </Typography>
                            
                            <Tooltip title="Сортировать паллеты по ID">
                                <IconButton size="small" onClick={handleIdSort} sx={{ ml: 1 }}>
                                    {idSortOrder === 'asc' && <NorthIcon fontSize="small" color="primary" />}
                                    {idSortOrder === 'desc' && <SouthIcon fontSize="small" color="primary" />}
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </div>

                    <Scrollbars
                        style={{height: "80%"}}
                    >
                        <CardContent>                  
                            {boxes.filter((fel) => fel.type === "pallet").map((parel, index) => (
                                <>
                                    <ListItemButton onClick={() => handleClick(parel.id)}
                                        disableRipple  
                                        sx={{
                                            borderRadius: '30px',
                                            backgroundColor: parel.open ? '#078476' : "ffffff",
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                            borderColor: parel.open ? '#065f52' : '#aaa8a8',
                                            marginBottom: parel.open? '0px': '10px',    
                                            '&:hover': {
                                                backgroundColor: parel.open ? '#065f52' : '#f1f1f1',
                                            },
                                        }}
                                    >

                                        <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                {/* <ListItemText primary={el.id} /> */}
                                                <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold', color: parel.open ? 'white' : "black"}}>{parel.title}</Typography>
                                                {parel.open ? <ExpandLess style={{color: 'white'}}/> : <ExpandMore style={{color: "black"}}/>}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center", width: "80%", justifyContent: 'space-between'}}>
                                                {parel.sku === 0 && <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black", width: "33%"}}>Коробов: {parel.box_count} </Typography>}
                                                {parel.box_count == 0?
                                                    <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black", width: "34%"}}>
                                                        SKU: {parel.sku}, Товаров: {parel.count}
                                                    </Typography>
                                                    :
                                                    <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black", width: "34%"}}>
                                                        SKU: {inPalletCount[parel.id]?.sku?.length || 0}, Товаров: {inPalletCount[parel.id]?.count || 0}
                                                    </Typography>
                                                }
                                                {MW.length > 0 && 
                                                    <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black", width: "33%"}}>
                                                        {inPalletCount[parel.id]?.subWarehouse || "Неизвестное направление"}
                                                    </Typography>
                                                }
                                            </div>
                                        </div>
                                    </ListItemButton>
                                    <Collapse in={parel.open} timeout="auto" unmountOnExit sx={{marginLeft: "10px"}}>
                                        {parel.sku > 0?
                                            <>
                                                {loading? <Loading/> :
                                                    <>
                                                        {data[parel.id]? 
                                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                {data[parel.id].map((datael) => {return productItem(parel, datael)})}
                                                            </div>    
                                                        :
                                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Паллет пустой</div>
                                                        }
                                                    </>
                                                }
                                            </>
                                            :
                                            <>
                                                {boxes.filter((fel) => fel.type === "box" && fel.parent_id === parel.id).map((el, index) => (
                                                    <>
                                                        <ListItemButton onClick={() => handleClick(el.id)}
                                                            sx={{
                                                                borderBottom: '2px solid #b9b9b9ff', 
                                                                backgroundColor: "ffffff",
                                                                borderRadius: '10px',
                                                                borderBottomRightRadius: '0px',
                                                                borderBottomLeftRadius: '0px'
                                                            }}
                                                        >
                                                            <div style={{width: '100%', display:'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                                                                <div style={{display:'flex', flexDirection: "row", alignItems: "center"}}>
                                                                    {/* <ListItemText primary={el.id} /> */}
                                                                    <Typography variant='subtitle2' align='left'>{el.title}</Typography> 
                                                                    {el.open ? <ExpandLess /> : <ExpandMore />}
                                                                                                            
                                                                </div>
                                                                <div style={{display:'flex', flexDirection: "row", alignItems: "center"}}>
                                                                    {el.subWarehouse ? (
                                                                        <EllipsisWithTooltip style={{ width: '150px', marginRight: '10px' }}>
                                                                            {el.subWarehouse}
                                                                        </EllipsisWithTooltip>
                                                                    ) : (<div style={{ width: '150px', marginRight: '10px' }} />)}
                                                                    <Typography variant='subtitle2' align='right' style={{ width: '100px', marginRight: '10px' }}>{el.sku} SKU, {el.count} шт.</Typography> 
                                                                    {el.market_code ?
                                                                        <Typography variant='subtitle2' align='right' style={{ width: '150px'}}>{el.market_code}</Typography>
                                                                    :
                                                                        <div style={{ width: '150px'}}></div>
                                                                    }
                                                                    <Tooltip title="ШК короба">
                                                                        <IconButton 
                                                                            aria-label="menu" 
                                                                            onClick={(event) => {event.stopPropagation(); showPdf(el.marcket_bc_path)}}
                                                                            disabled={!el.marcket_bc_path}
                                                                        >
                                                                            <PictureAsPdfIcon
                                                                                sx={{
                                                                                    transition: 'all 0.3s ease',
                                                                                    '&:hover': hoverStyle
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Другие функции">
                                                                        <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); handleClickMenuOpen(event, el.id) }}>
                                                                            <MoreVertIcon
                                                                                sx={{
                                                                                    transition: 'all 0.3s ease',
                                                                                    '&:hover': hoverStyle
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Menu
                                                                        anchorEl={el.openMenu}
                                                                        open={Boolean(el.openMenu)}
                                                                        onClose={() => handleClickMenuClose(el.id)}
                                                                        MenuListProps={{
                                                                            'aria-labelledby': 'basic-button',
                                                                        }}
                                                                    >
                                                                        {el.market_code && <MenuItem onClick={(event) => { event.stopPropagation(); handleClickDelBarcodeOnId(el.id)}}>Удалить ШК</MenuItem>}
                                                                        <MenuItem onClick={(event) => { event.stopPropagation(); handleClickSetBarcodeOnId(el.id)}}>{el.market_code? "Заменить": "Установить"} ШК</MenuItem>
                                                                    </Menu>
                                                                </div>
                                                            </div>
                                                        </ListItemButton>
                                                        <Collapse in={el.open} timeout="auto" unmountOnExit>
                                                            {loading? <Loading/> :
                                                                <>
                                                                {data[el.id]? 
                                                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                        {data[el.id].map((datael) => {return productItem(el, datael)})}
                                                                    </div>    
                                                                :
                                                                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Короб пустой</div>
                                                                }
                                                                </>
                                                            }
                                                        </Collapse>
                                                    </>
                                                ))}
                                            </>
                                        }
                                    </Collapse>
                                </>
                            ))}
                            {/* КООРБА БЕЗ ПАЛЛЕТА */}
                            {boxes.filter((fel) => fel.type === "box" && !fel.parent_id).length > 0 &&
                                <>
                                    <ListItemButton onClick={() => setNoPalletOpen(!noPalletOpen)}
                                        sx={{
                                            borderRadius: '30px',
                                            backgroundColor: noPalletOpen ? '#078476' : "ffffff",
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                            borderColor: noPalletOpen ? '#065f52' : '#aaa8a8',
                                            marginBottom: '10px',
                                            '&:hover': {
                                                backgroundColor: noPalletOpen ? '#065f52' : '#f1f1f1',
                                            },
                                        }}
                                    >

                                        <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold', color: noPalletOpen ? 'white' : "black"}}>Короба без паллета</Typography>
                                                {noPalletOpen ? <ExpandLess sx={{color: 'white'}}/> : <ExpandMore sx={{color: 'black'}}/>}
                                            </div>
                                        </div>
                                    </ListItemButton>
                                    <Collapse in={noPalletOpen} timeout="auto" unmountOnExit sx={{marginLeft: "10px"}}>
                                        {boxes.filter((fel) => fel.type === "box" && !fel.parent_id).map((el, index) => (
                                            <>
                                                <ListItemButton onClick={() => handleClick(el.id)}
                                                    sx={{
                                                        borderBottom: '2px solid #b9b9b9ff', 
                                                        backgroundColor: "ffffff",
                                                        borderRadius: '10px',
                                                        borderBottomRightRadius: '0px',
                                                        borderBottomLeftRadius: '0px'
                                                    }}
                                                >
                                                    <div style={{width: '100%', display:'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                                                        <div style={{display:'flex', flexDirection: "row", alignItems: "center"}}>
                                                            {/* <ListItemText primary={el.id} /> */}
                                                            <Typography variant='subtitle2' align='left'>{el.title}</Typography> 
                                                            {el.open ? <ExpandLess /> : <ExpandMore />}
                                                        </div>
                                                        <div style={{display:'flex', flexDirection: "row", alignItems: "center"}}>
                                                            {el.subWarehouse ? (
                                                                <EllipsisWithTooltip style={{ width: '150px', marginRight: '10px' }}>
                                                                    {el.subWarehouse}
                                                                </EllipsisWithTooltip>
                                                            ) : (<div style={{ width: '150px', marginRight: '10px' }} />)}
                                                            <Typography variant='subtitle2' align='right' style={{ width: '100px', marginRight: '10px' }}>{el.sku} SKU, {el.count} шт.</Typography> 
                                                            {el.market_code ?
                                                                <Typography variant='subtitle2' align='right' style={{ width: '150px'}}>{el.market_code}</Typography>
                                                            :
                                                                <div style={{ width: '150px'}}></div>
                                                            }
                                                            <Tooltip title="ШК короба">
                                                                <IconButton 
                                                                    aria-label="menu" 
                                                                    onClick={(event) => {event.stopPropagation(); showPdf(el.marcket_bc_path)}}
                                                                    disabled={!el.marcket_bc_path}
                                                                >
                                                                    <PictureAsPdfIcon
                                                                        sx={{
                                                                            transition: 'all 0.3s ease',
                                                                            '&:hover': hoverStyle
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Другие функции">
                                                                <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); handleClickMenuOpen(event, el.id) }}>
                                                                    <MoreVertIcon
                                                                        sx={{
                                                                            transition: 'all 0.3s ease',
                                                                            '&:hover': hoverStyle
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Menu
                                                                anchorEl={el.openMenu}
                                                                open={Boolean(el.openMenu)}
                                                                onClose={() => handleClickMenuClose(el.id)}
                                                                MenuListProps={{
                                                                    'aria-labelledby': 'basic-button',
                                                                }}
                                                            >
                                                                {el.market_code && <MenuItem onClick={(event) => { event.stopPropagation(); handleClickDelBarcodeOnId(el.id)}}>Удалить ШК</MenuItem>}
                                                                <MenuItem onClick={(event) => { event.stopPropagation(); handleClickSetBarcodeOnId(el.id)}}>{el.market_code? "Заменить": "Установить"} ШК</MenuItem>
                                                                {!FBSDATA && <MenuItem onClick={() => {chooseLocateQRListDownload(el.id)}} disabled={!el.qrList || el.qrList.length === 0}>Скачать список КИЗов</MenuItem>}
                                                            </Menu>
                                                        </div>
                                                    </div>
                                                </ListItemButton>
                                                <Collapse in={el.open} timeout="auto" unmountOnExit>
                                                    {loading? <Loading/> :
                                                        <>
                                                            {data[el.id]? 
                                                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                    {data[el.id].map((datael) => {return productItem(el, datael)})}
                                                                </div>    
                                                            :
                                                                <></>
                                                            }
                                                        </>
                                                    }
                                                </Collapse>
                                            </>
                                        ))}
                                    </Collapse>
                                </>
                            }
                        </CardContent>
                    </Scrollbars>
                </Card>
                <Card sx={{ borderRadius: '10px', boxShadow: 0, width: "35%", height:"100%"}}>
                    <CardContent sx={{ height:"100%"}}> 
                        {/* <Typography variant='h3' align='left'>Нераспределенный товар</Typography>                 
                        <Scrollbars
                            style={{height: "85%"}} autoHide
                        >
                            <ReportTable
                                ds={nbds}
                                data={data['0']?.filter((fel) => fel.countProduct> 0) || []}
                            />
                        </Scrollbars> */}
                        <Tabs value={tab} aria-label="basic tabs example" onChange={changeTab}>
                            <Tab label='Нераспределенный товар' value={'main'} />
                            {MW.length > 0  && <Tab label='Распределение по складам' value={'sub'} />}
                        </Tabs>
                        <div style={{display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: 'center'}}>
                            <ClassicSearch 
                                setChecked={setCheckedSub} 
                                setFilter={setFilterSub} 
                                checked={checkedSub}
                                // @ts-ignore
                                fields={tab === 'main'? filterFields: filterFieldsMW}
                                // @ts-ignore
                                setFields={tab === 'main'? setFilterFields: setFilterFieldsMW }
                                // @ts-ignore
                                customWidth={"50%"}
                            />
                            {MW.length > 0 && tab === 'sub' &&
                                <div style={{display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: 'center'}}>
                                    <Select
                                        displayEmpty
                                        value={filterWarehouse}
                                        onChange={(event) => {setFilterWarehouse(event.target.value) }}
                                        sx={{ width: "200px", height: "25px", marginRight: "10px" }}
                                    >
                                        <MenuItem key={'menu_all'} value={undefined} style={{ borderRadius: '10px', marginBottom: '5px' }}>Все</MenuItem>
                                        {avaibleWarehouses.map(sel => { return <MenuItem key={sel} value={sel} style={{ borderRadius: '10px', marginBottom: '5px' }} onClick={(event) => { event.stopPropagation() }}>{sel}</MenuItem> })}
                                    </Select>
                                </div>
                            }
                        </div>

                        <TabPanel select={tab} value={'main'}>
                            <Scrollbars
                                style={{ height: "80%" }} autoHide
                            >
                                <ReportTable
                                    ds={nbds}
                                    // data={data["0"] || []}
                                    data={
                                        !checkedSub? data['0']?.filter((el) => el.countProduct > 0):
                                        data["0"].filter((el) => {
                                            const tf = filterSub.toLowerCase();
                                            return (
                                                el.countProduct > 0 &&
                                                filterFields.title.active &&
                                                el.data.title &&
                                                String(el.data.title).toLowerCase().includes(tf) ||
                                                filterFields.brand.active &&
                                                el.data.brand &&
                                                String(el.data.brand).toLowerCase().includes(tf) ||
                                                filterFields.vendorCode.active &&
                                                el.data.vendorCode &&
                                                String(el.data.vendorCode).toLowerCase().includes(tf) ||
                                                filterFields.barcode.active &&
                                                el.size.barcode &&
                                                el.size.barcode.toLowerCase().includes(tf)
                                            )
                                        })
                                    }
                                />
                            </Scrollbars>
                        </TabPanel>
                        <TabPanel select={tab} value={'sub'}>
                            <Scrollbars
                                style={{ height: "80%" }} autoHide
                            >
                                <ReportTable
                                    ds={mwds}
                                    data={
                                        !checkedSub? 
                                            !filterWarehouse? MW: MW.filter((fel) => fel.warehouse === filterWarehouse)
                                        :
                                            (!filterWarehouse? MW: MW.filter((fel) => fel.warehouse === filterWarehouse)).filter((el) => {
                                                const tf = filterSub.toLowerCase();
                                                return (
                                                    filterFieldsMW.warehouse.active &&
                                                    el.warehouse &&
                                                    el.warehouse.toLowerCase().includes(tf)
                                                )
                                        })
                                    }
                                />
                            </Scrollbars>
                        </TabPanel>
                    </CardContent>
                </Card>
            </div>
    </div>
    )
}

function BoxCustomPdfModal({ path }) {
    // состояние для хранения таблицы файлов, выбранных файлов, выбранных страниц, открытого файла и общего количества страниц
    // а также состояния загрузки
    
    /** @type {[any, Function]} */
    const [image, setImage] = useState(undefined)
    const [customBCLoad, setCustomBCLoad] = useState(true)
    const [isPortrait, setIsPortrait] = useState(false)
    const [imageLoaded, setImageLoaded] = useState(false)

    // Эффект для определения ориентации изображения после загрузки
    useEffect(() => {
        if (image) {
            const img = new Image();
            img.onload = () => {
                setIsPortrait(img.height > img.width);
                setImageLoaded(true);
            };
            img.src = image;
        }
    }, [image]);

    useEffect(() => {
        if (path) {
            const checkPhoto = async () => {
                console.log("path", path)
                try {
                    setCustomBCLoad(true);
                    setImageLoaded(false); // Сбрасываем флаг загрузки
                    let tmp = await getFile("png", { path:path });
                    if (typeof tmp === "string") {
                        setImage(tmp);
                    }
                }
                catch (err) {
                    console.error("Error loading image:", err);
                }
                finally {
                    setCustomBCLoad(false);
                }
            }

            checkPhoto();
        }
    }, [path]);

    const scale = 1.5

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{
                width: "100%",
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                boxSizing: 'border-box'
            }}>
                {customBCLoad ? <Loading></Loading> :
                    <>
                    {image && imageLoaded &&
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            transform: `scale(${scale})`, 
                            transformOrigin: '0 0', 
                            width: `${100 / scale}%`, 
                            height: `${100 / scale}%`,
                            alignItems: "center"
                        }}>
                            <Card 
                                sx={{ 
                                    borderRadius: 3, 
                                    padding: "0px",
                                    width: isPortrait ? "40mm" : "58mm",
                                    height: isPortrait ? "58mm" : "40mm"

                                }}
                            >
                                <CardContent sx={{ 
                                    // padding: "2mm", 
                                    // marginTop: "1.2mm",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>   
                                    <img 
                                        src={image} 
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            // objectFit: "cover",
                                            objectFit: "contain",
                                            display: "block"
                                        }}
                                        alt="Штрих-код"
                                    />
                                </CardContent>
                            </Card>
                        </div>
                    }
                    </>
                }
            </Box>
        </div>
    );
}

const ItemPay = ({ data }) => {
    let [open, setOpen] = useState(false);
    return (
        <>
            <ListItemButton onClick={() => setOpen(JSON.parse(JSON.stringify(!open)))}>
                <ListItemText primary={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h4">{data.action}</Typography>
                    <Typography variant="h4">{`${data.price} р.`}</Typography></div>} />
                {open === true ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {data.subActions.map((value) =>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.5% 2% 0.5% 4%' }}>
                            <Typography variant="subtitle1">{Object.keys(value)[0]}</Typography>
                            <Typography variant="subtitle1">{`${Object.values(value)[0]} р.`}</Typography>
                        </div>
                    )}
                </List>
            </Collapse>
        </>
    );
}

function PayDeal({ $data, setInfo }) {
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([])
    const [sum, setSum] = useState(0)
    const [loading, setLoading] = useState(false)
    const ds = useMemo(() => getDataSource('DealPayClient'), []);
    const [dealNumber, setDealNumber] = useState(null);
    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)
    const [allEtimated, setAllEtimated] = useState(0)
    const [allDefect, setAllDefect] = useState(0)
    

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ 
                        fontSize: '14pt', 
                        fontWeight: 'bold', 
                        margin: '5px 15px 5px 10px',
                        color: '#078376'
                    }}>
                        Номер сделки: {dealNumber}
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        SKU: {allSKU} шт.
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        Брак: <Typography component="span" sx={{ fontSize: '12pt', color: allDefect !== 0 ? 'red' : 'inherit' }}>{allDefect} шт.</Typography>
                    </Typography>                            
                    
                    {allEtimated > 0 &&
                        <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px' }}>
                            Заявлено: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated ? 'red' : 'inherit' }}>{allEtimated} шт.</Typography>
                        </Typography>
                    }
                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px' }}>
                        Фактически: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated && allEtimated > 0 ? 'red' : 'inherit' }}>{allProduct} шт.</Typography>
                    </Typography>
                </>
            )
        }
        setInfo(getInfo())
    }, [dealNumber, allSKU, allDefect, allEtimated, allProduct]);
            

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);

            
            const res = await get("Deal/GetPay", {did:$data})
            const res2 = await get("Deal/GetDeliveryProductOnDeal", {did:$data})
            let tmp = []
            let c = 0

            
            console.log("test", data)
            let dataprod = res2
            let allsku = 0
            let allproduct = 0
            let alletimated = 0
            let alldefect = 0
            if (dataprod && dataprod.length > 0){
                allsku = dataprod.length
                for(let i = 0 ; i < dataprod.length ; i++){
                    allproduct += dataprod[i].countProduct;
                    alletimated += dataprod[i].countEtimated;
                    alldefect += dataprod[i].countDefectHist; //Используем hist, чтобы не отображать временные данные ине терять найденную инфу
                }
            }
            
            setAllSKU(allsku)
            setAllEtimated(alletimated)
            setAllProduct(allproduct)
            setAllDefect(alldefect)
            setData(res.message)

            const responseData = await get('Deal/getHeader', {did:$data})
            if (responseData && responseData.cdn) {
                setDealNumber(responseData.cdn);
            }
        }
        catch {}
        finally {setLoading(false);}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        let tmp = 0
        data.map((el) => {tmp += el.price})
        setSum(tmp)
    }, [data])

    if (loading) return (<Loading></Loading>)

    return (
        <div style={{display: "flex", flexDirection: "column", height: "calc(94% - 55px )", margin: '0% 1% 1% 1%'}}>

            <div style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', height: "100%", borderRadius: '10px' }}>
                <Scrollbars
                    style={{height: "90%"}} autoHide
                >
                    <ReportTable
                        ds={ds}
                        data={data}
                    />
                </Scrollbars>
                <div style={{ 
                        borderLeft: '4px solid' + colors.elements, 
                        margin: '20px 20px 20px 10px', 
                        display: 'flex', 
                        flexDirection: 'row', 
                        justifyContent: 'space-between', 
                        height:"10%", 
                        width: "100%" 
                    }}
                >
                    <div style={{marginLeft: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Typography variant="h2" >{`Итоговая стоимость:`}</Typography>
                        <Typography variant="h2">{sum}</Typography>
                    </div>
                </div>
            </div>

        </div>
    );
}


export function DealClient() {
    const [tab, setTab] = useState(undefined);


    const [info, setInfo] = useState(undefined)
    const [search, setSearch] = useState(undefined)

    const { dealId } = useParams();

    const handleChange = (event, newTab) => {
        setInfo(undefined)
        setSearch(undefined)
        setTab(newTab);
        sessionStorage.setItem(`DEALTAB_cli_${dealId}`, newTab)
    };

    

    useEffect(() => {
        handleChange(undefined, Number(sessionStorage.getItem(`DEALTAB_cli_${dealId}`)) || 0)
    }, []);

    
    return (
        <Box sx={{ width: '100%', height: '100%'}}>
            <div style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    height: "5%", 
                    margin: "10px 1% 10px 1%"
                }}
            >
                {search || <div></div>}

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '10px',
                    }}>
                        {!info? 
                            <Loading/>
                        :
                            info
                        }
                    </Box>
                </div>
            </div>
            <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                margin: '0% 0% 0% 1%',
                height: "30px",
                minHeight: "30px"
            }}>
                <DealTab label="ТАБЛИЦА" />
                <DealTab label="ПРИВЯЗКА" />
                <DealTab label="ОПЛАТА" />
            </Tabs>
            <TabPanel value={0} select={tab}>
                {<TableDeal $data={dealId} setInfo={setInfo} setSearch={setSearch}></TableDeal>}
            </TabPanel>
            <TabPanel value={1} select={tab}>
                {<BindDeal $data={dealId} setInfo={setInfo}></BindDeal>}
            </TabPanel>
            <TabPanel value={2} select={tab}>
                {<PayDeal $data={dealId} setInfo={setInfo}></PayDeal>}
            </TabPanel>

        </Box>
    );
}


